import { Component } from "@angular/core";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { WorkOrderService } from "@services/workOrder.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "spotOrders",
	styleUrls: ["spotOrders.css"],
	templateUrl: "spotOrders.html"
})
export class EdiSpotOrdersReportAdminComponent {
	headerPrimaryButtons: AdminHeaderButton[] = [{ method: "downloadPickListPdf", text: "Pick List" }];
	spotOrdersReportTable: any;
	title = "Spot Orders Report";

	constructor(private toastService: ToastService, private workOrderService: WorkOrderService) {
		this.getSpotOrdersReport();
	}

	downloadPickListPdf() {
		const date = new Date();
		this.workOrderService.pickList().subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", date.toDateString() + "_SpotOrders_Picklist.pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	getSpotOrdersReport() {
		this.workOrderService.spotOrdersReport()
			.subscribe(
				(res: any) => {
					this.spotOrdersReportTable = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}
}